import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import {
  loadAllMeetingReports,
  loadSingleMeetingReport,
} from "./MeetingReportsList.slice";

import {
  loadAllMeetingReportsAPI,
  loadSingleMeetingReportAPI,
} from "./MeetingReportsList.api";

export const LOAD_ALL_MEETING_REPORTS = {
  LOADING: "Load all meeting loading",
  SUCCESS: "Load all meeting success",
  ERROR: "Load all meeting error",
};

export const LOAD_SINGLE_MEETING_REPORT = {
  LOADING: "Load single meeting loading",
  SUCCESS: "Load single meeting success",
  ERROR: "Load single meeting error",
};

function* loadAllMeetingReportsWorker(action) {
  const { payload } = action;
  try {
    const data = yield call(loadAllMeetingReportsAPI, payload);
    yield put(loadAllMeetingReports(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_MEETING_REPORTS.ERROR, error });
  }
}

function* loadSingleMeetingReportSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleMeetingReportAPI, payload);
    yield put(loadSingleMeetingReport(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_MEETING_REPORT.ERROR, error });
  }
}

export function* loadAllMeetingReportsSaga() {
  yield takeLatest(
    LOAD_ALL_MEETING_REPORTS.LOADING,
    loadAllMeetingReportsWorker
  );
}

export function* loadSingleMeetingReportSaga() {
  yield takeLatest(
    LOAD_SINGLE_MEETING_REPORT.LOADING,
    loadSingleMeetingReportSagaWorker
  );
}
